export const DEFAULT_LOGO = '/assets/chandana-aura-logo.png';
